import React from "react";

import { Navbar } from "../../../components";
import { Ideal } from "./Ideal";

const IdealProject = () => {
  return (
    <div className="app">
      <Navbar />
      <Ideal />
    </div>
  );
};

export default IdealProject;
